import { styled, Typography } from '@mui/material';
import React from 'react';
import Layout from '../components/Layout';
import SupportCenterFaq from '../components/supportCenterFaq';
import SupportCenterInstruction from '../components/supportCenterInstruction';
import { colors } from '../styles/globalStyles';

import Arrow from '../images/support-center/arrow.svg';

import textData from '../data/data.json';
import { selectedLanguageAtom } from '../recoil/atoms/languageAtom';
import { useRecoilValue } from 'recoil';

const Title = styled(Typography)({
    fontWeight: 700,
    fontSize: 24,
    lineHeight: '24px',
    marginLeft: 10,
    '& .accent': {
        color: colors.main,
    },
});

const arrowStyles = 'display: block; opacity: .7; margin: 20px auto';

const SupportCenterPage = () => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);
    const { supportCenterPage } = textData[selectedLanguage];
    const instructionData = [
        {
            titleText: supportCenterPage.instructions.items.home.titleText,
            title: supportCenterPage.instructions.items.home.title,
            text: `
      <p>${supportCenterPage.instructions.items.home.paragraphs[0]}</p>
      <p>${supportCenterPage.instructions.items.home.paragraphs[1]}</p>
      <img src=${supportCenterPage.instructions.items.home.images[0]} alt='home' width='100%' height='100%' />
    `,
        },
        {
            titleText: supportCenterPage.instructions.items.sessions.titleText,
            title: supportCenterPage.instructions.items.sessions.title,
            text: `
      <p>${supportCenterPage.instructions.items.sessions.mainText}</p>

      <br>
      <p><i>${supportCenterPage.instructions.items.sessions.sections[0].title}</i></p>
      <p>${supportCenterPage.instructions.items.sessions.sections[0].selfRating}</p>
      <img src=${supportCenterPage.instructions.items.sessions.images[0]} alt='sessions' width='100%' height='100%' />
      <img src=${Arrow} alt='arrow' width='24px' height='24px' style='${arrowStyles}' />
      <img src=${supportCenterPage.instructions.items.sessions.images[1]} alt='sessions' width='100%' height='100%' />

      <p>${supportCenterPage.instructions.items.sessions.sections[0].colleaguesRating}</p>
      <img src=${supportCenterPage.instructions.items.sessions.images[2]} alt='sessions' width='100%' height='100%' />
      <img src=${Arrow} alt='arrow' width='24px' height='24px' style='${arrowStyles}' />
      <img src=${supportCenterPage.instructions.items.sessions.images[3]} alt='sessions' width='100%' height='100%' />

      <br>
      <p><i>${supportCenterPage.instructions.items.sessions.sections[1].title}</i></p>
      <p>${supportCenterPage.instructions.items.sessions.sections[1].text}</p>
      <img src=${supportCenterPage.instructions.items.sessions.images[4]} alt='sessions' width='100%' height='100%' />
      <img src=${Arrow} alt='arrow' width='24px' height='24px' style='${arrowStyles}' />
      <img src=${supportCenterPage.instructions.items.sessions.images[5]} alt='sessions' width='100%' height='100%' />
      <img src=${Arrow} alt='arrow' width='24px' height='24px' style='${arrowStyles}' />
      <img src=${supportCenterPage.instructions.items.sessions.images[6]} alt='sessions' width='100%' height='100%' />
      <img src=${Arrow} alt='arrow' width='24px' height='24px' style='${arrowStyles}' />
      <img src=${supportCenterPage.instructions.items.sessions.images[7]} alt='sessions' width='100%' height='100%' />
      <p>${supportCenterPage.instructions.items.sessions.sections[1].note}</p>
    `,
        },
        {
            titleText: supportCenterPage.instructions.items.tracker.titleText,
            title: supportCenterPage.instructions.items.tracker.title,
            text: `
      <p>${supportCenterPage.instructions.items.tracker.text}</p>

      <img src=${supportCenterPage.instructions.items.tracker.images[0]} alt='tracker' width='100%' height='100%' />
      <img src=${Arrow} alt='arrow' width='24px' height='24px' style='${arrowStyles}' />
      <img src=${supportCenterPage.instructions.items.tracker.images[1]} alt='tracker' width='100%' height='100%' />
      <img src=${Arrow} alt='arrow' width='24px' height='24px' style='${arrowStyles}' />
      <img src=${supportCenterPage.instructions.items.tracker.images[2]} alt='tracker' width='100%' height='100%' />
    `,
        },
        {
            titleText: supportCenterPage.instructions.items.progress.titleText,
            title: supportCenterPage.instructions.items.progress.title,
            text: `
      <p>${supportCenterPage.instructions.items.progress.intro}</p>
      <br>
      <p><i>${supportCenterPage.instructions.items.progress.sections[0].title}</i></p>
      <p>${supportCenterPage.instructions.items.progress.sections[0].description}</p>
      <p>${supportCenterPage.instructions.items.progress.sections[0].items[0]}</p>
      <p>${supportCenterPage.instructions.items.progress.sections[0].items[1]}</p>
      <p>${supportCenterPage.instructions.items.progress.sections[0].items[2]}</p>
      <p>${supportCenterPage.instructions.items.progress.sections[0].items[3]}</p>
      <br>
      <img src=${supportCenterPage.instructions.items.progress.images[0]} alt='progress' width='100%' height='100%' />
      <br>
      <br>

      <p>${supportCenterPage.instructions.items.progress.sections[0].note}</p>
      <img src=${supportCenterPage.instructions.items.progress.images[1]} alt='progress' width='100%' height='100%' />
      <img src=${Arrow} alt='arrow' width='24px' height='24px' style='${arrowStyles}' />
      <img src=${supportCenterPage.instructions.items.progress.images[2]} alt='progress' width='100%' height='100%' />
      <br>
      <br>

      <p><i>${supportCenterPage.instructions.items.progress.sections[1].title}</i></p>
      <p>${supportCenterPage.instructions.items.progress.sections[1].text}</p> 
      <img src=${supportCenterPage.instructions.items.progress.images[3]} alt='progress' width='100%' height='100%' />
      <br>
      <br>

      <p><i>${supportCenterPage.instructions.items.progress.sections[2].title}</i></p>
      <p>${supportCenterPage.instructions.items.progress.sections[2].text}</p> 
      <img src=${supportCenterPage.instructions.items.progress.images[4]} alt='progress' width='100%' height='100%' />
    `,
        },
    ];

    return (
        <Layout link={'/'}>
            <Title>
                <span className="accent">{supportCenterPage.accentTitle}</span> {supportCenterPage.title}
            </Title>
            <SupportCenterInstruction data={instructionData} />
            <SupportCenterFaq data={supportCenterPage.faq} />
        </Layout>
    );
};

export default SupportCenterPage;
